<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <DocumentsGroupTableItem
      v-for="item in items"
      :key="item.id"
      :item="item"
      :tableMin="tableMin"
      :functionDownloadPageData="functionDownloadPageData"
    />
  </BaseTableView>
</template>

<script>
import DocumentsGroupTableItem from 'components/documents/DocumentsGroupTableItem'
import BaseTableView from 'components/base/tableview/BaseTableView'

export default {
  name: 'DocumentsGroupTable',
  props: { items: Array, functionDownloadPageData: Function },
  components: { BaseTableView, DocumentsGroupTableItem },
  data() {
    return {
      tableMin: false,
    }
  },
  computed: {
    tableHead() {
      let result = [
        {
          text: this.localStorage.translations.pages['setting-free_documents']['tables']['name'],
        },
      ]
      if (this.$route.meta.requestType === 'admin') {
        result[0].sort = {
          name: 'name',
          value:
            this.$route.query.sort_param && this.$route.query.sort_param === 'name'
              ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                ? 'asc'
                : 'desc'
              : 'desc',
        }
        result.push({
          text: this.localStorage.translations.pages['setting-free_documents']['tables']['access'],
        })
      }
      if (
        this.$userCheckAccess({
          abilities: 'edit_free_documents',
        })
      ) {
        result.push({ active: true })
      }
      return result
    },
  },
  methods: {
    onMin(value) {
      this.tableMin = value
    },
  },
}
</script>
